import { userDataFromStorage } from '@components/AuthContext';
import { BUILD_VERSION, IS_PR_PREVIEW, USE_LD } from '@utils/constants';
import { LDContext } from 'launchdarkly-js-client-sdk';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { FC, PropsWithChildren, ReactNode } from 'react';

const FakeLDProvider: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <>{children}</>
);

const anonmyousUser = {
  anonymous: true,
  key: 'anonymous',
};

interface initLDProps {
  launchDarklyKey: string;
  appName?: string;
  env?: string;
  additionalContext?: Record<string, unknown>;
}

export const initLD = async (
  props: initLDProps,
): Promise<FC<{ children: ReactNode }>> => {
  let slim;
  if (props.appName === 'connect-carrier-frontend') {
    const slimImport = await import('@generated/flags/slim-connect-carrier');
    slim = slimImport.slim;
  } else {
    const slimImport = await import('@generated/flags/slim');
    slim = slimImport.slim;
  }
  /* istanbul ignore next: we do not use real LD in tests */
  if (USE_LD) {
    let context: LDContext = {
      kind: 'user',
      ...(userDataFromStorage || anonmyousUser),
    };
    if (props.appName) {
      context = {
        kind: 'multi',
        user: {
          ...(userDataFromStorage || anonmyousUser),
        },
        component: {
          kind: 'component',
          key: props.appName,
        },
        env: {
          kind: 'env',
          key: props.env,
        },
        ...props.additionalContext,
      };
    }
    return asyncWithLDProvider({
      clientSideID: props.launchDarklyKey,
      context,
      options: {
        bootstrap: 'localStorage',
        application: {
          id: props.appName ?? 'mastermind-frontend',
          version: (BUILD_VERSION ?? IS_PR_PREVIEW) ? 'pull' : 'unknown',
        },
      },
      reactOptions: {
        // https://docs.launchdarkly.com/docs/react-sdk-reference#section-flag-keys
        useCamelCaseFlagKeys: false,
      },
      flags: slim,
    });
  }
  return Promise.resolve(FakeLDProvider);
};
